import { useEffect, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import { addDays } from 'date-fns';
import moment from 'moment';
import { RenderIf } from 'utilities/helpers';
import Container, { Column, Row } from 'layouts/container';
import { Button } from 'components/button';
import { useCountry } from 'contexts/CountryContext';
import SpikeHead from './../../assets/Images/spike_head.png';
import SpikeBody from './../../assets/Images/spike_body.png';
import TrackChannelGradient from './../../assets/Images/track_channel_gradient.png';
import TrackChannel from './../../assets/Images/track_channel.png';
import PolygonEmpty from './../../assets/Images/polygon_empty.png';
import PredictedSale from './../../assets/Images/predicted_sale.png';
import PredictionEmpty from './../../assets/Images/prediction_empty.png';
import { CardV1, CardV2, CardV3 } from './cardv1';
import EventSlider from './eventSlider';
import DemandSpikeChart from './demandSpikeChart';
import ChannelPerformanceChart from './channelPerformanceChart';
import DemandBarChart from './demandBarChart';
import PredictionPloygonMap from './../../assets/Images/prediction_polygon_map.png';
import AvatarItem1 from './../../assets/Images/avatar_item_1.png';
import { Ikon } from 'assets/icons';
import styles from './index.module.css';
import PredictedSaleBarChart from './predictedSaleBarChart';

const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
    placement: "left",
  },
  {
    label: "Yesterday",
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: "left",
  },
  {
    label: "Last week",
    value: [addDays(new Date(), -7), new Date()],
    placement: "left",
  },
  {
    label: "Last month",
    value: [addDays(new Date(), -30), new Date()],
    placement: "left",
  },
  {
    label: "Last year",
    value: [addDays(new Date(), -364), new Date()],
    placement: "left",
  },
];

const data = [
  {
    inventory: '142K', // Will be formatted with currency symbol when displayed
    products: '15.3K',
    expiringMixtures: '5',
    expiringIngredients: '5',
    expiringItems: '23',
  }
];

export const DemandSensingPage = () => {
  const { formatCurrency, dateFormat } = useCountry();
  const pickerFormat = dateFormat === 'DD/MM/YYYY' ? 'dd/MM/yyyy' : dateFormat === 'DD-MM-YYYY' ? 'dd-MM-yyyy' : 'MM/dd/yyyy';

  return (
    <Column padding={'30px 0'} gap={30}>
      <Column padding={20} gap={20} style={{ background: '#CFC3FBB5', borderRadius: 14, }}>
        <Row gap={20}>
          <Column gap={5}>
            <div className={styles.subHead}>Stay Stocked, Stay Ready.</div>
            <h5 className={styles.h5}>Predict what's selling next and adjust inventory levels with precision to avoid overstock and out-of-stock situations.</h5>
          </Column>
          <div>
            <Button 
              onClick={() => {}} 
              style={{
                background: 'transparent',
                padding: 0,
                borderRadius: 0,
                lineHeight: 0,
                height: 'auto',
              }} 
            >
              <Ikon name={'close-x'} />
            </Button>
          </div>
        </Row>
        <div>
          <Button 
            onClick={() => {}} 
            style={{
              background: '#EDF2F7',
              padding: '10.5px 18px',
              borderRadius: 10,
              fontWeight: '400',
              fontSize: 16,
              color: '#16192C',
            }} 
          >
            Optimize Inventory
          </Button>
        </div>
      </Column>
      <Row gap={16}>
        <Column gap={5}>
            <h2 className={styles.h2}>Demand Sensing</h2>
            <p className={styles.p}>Identify high-demand items and streamline preparation to meet customer expectations.</p>
        </Column>
          <Button 
            onClick={() => {}} 
            style={{
              gap: 6,
              background: '#D5D5DC',
              padding: '10px 15px',
              borderRadius: 6,
              fontWeight: '400',
              fontSize: 14,
              color: '#16192C',
            }} 
          >
            <Ikon name={'export'} />
            Export
          </Button>
      </Row>
      <RenderIf isTrue={data?.length === 0}>
        <Column gap={21} padding={'20px 7.5px'} style={{
          background: '#FFFFFF',
          border: '#EDF2F7 1px solid',
          borderRadius: 10,
          boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
        }}>
          <Container maxWidth={1038}>
            <Column gap={'0'} padding={'19px 20px'} style={{
              border: '#EDF2F7 1px solid',
              borderRadius: 10,
              boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D;',
            }}>
              <Row gap={32} alignItems={'center'} style={{ minHeight: 85, }}>
                <Column gap={'0'} style={{ maxWidth: 302 }}>
                  <h4 className={styles.h4}>Upcoming Events</h4>
                </Column>
                <Column gap={5} style={{ flex: 1, textAlign: 'center', }} alignItems={'center'}>
                  <h5 className={styles.h5}>You don't have any Data!</h5>
                  <p className={styles.p2}>Once you start selling, your data will appear here.</p>
                </Column>
              </Row>
            </Column>
          </Container>
          <Row gap={25}>
            <Column gap={32} padding={'26px 40px'} style={{ border: '1px solid #EDF2F7', borderRadius: 16, flex: 1, }}>
              <img src={SpikeHead} alt='' width={'100%'} height={'auto'} />
              <img src={SpikeBody} alt='' width={'100%'} height={'auto'} />
            </Column>
            <Column gap={16} padding={20} style={{
              maxWidth: 276,
              backgroundImage: `url(${TrackChannelGradient})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundColor: '#F7F9FB',
              borderRadius: 12,
            }}>
              <Column gap={8} style={{ flex: 1, }}>
                <Column gap={5} style={{ minHeight: 99, }}>
                  <h5 className={styles.h5}>Track Channels Conversion</h5>
                  <p className={styles.p3}>See which channel brings more sales and conversions during the spike.</p>
                </Column>
                <img src={TrackChannel} alt='' width={'100%'} height={'auto'} />
              </Column>
              <div>
                <Button 
                  onClick={() => {}} 
                  style={{
                    gap: 4,
                    background: '#000000AB',
                    padding: '12px 12px',
                    borderRadius: 10,
                    fontWeight: '500',
                    fontSize: 13,
                    color: '#FFFFFF',
                  }} 
                >
                  <Ikon name={'right-go'} />
                  Explore Campaigns
                </Button>
              </div>
            </Column>
          </Row>
          <Column gap={14} padding={'0 13px 26px'}>
            <h4 className={styles.h4}>Prediction Polygon</h4>
            <img src={PolygonEmpty} alt='' width={'100%'} height={'auto'} style={{ borderRadius: 14, }} />
          </Column>
          <Column gap={20} padding={'0 0 0 22px'}>
            <h4 className={styles.h4}>Predicted Sales</h4>
            <img src={PredictedSale} alt='' width={'100%'} height={'auto'} />
          </Column>
        </Column>
        <Column gap={16}>
          <Row gap={15} justifyContent={'flex-end'}>
            <div>
              <Button 
                onClick={() => {}} 
                style={{
                  padding: '10.5px 18px',
                  borderRadius: 10,
                  background: '#A561D8',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontSize: 16,
                }} 
              >
                View Inventory
              </Button>
            </div>
          </Row>
          <Column gap={21} padding={'36px 23px 80px'} style={{
            background: '#FFFFFF',
            border: '#EDF2F7 1px solid',
            borderRadius: 10,
            boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
          }}>
            <h4 className={styles.h4}>Predictions</h4>
            <Column gap={50} padding={20} style={{
              border: '#E6E6E6 1px solid',
              borderRadius: 15,
              textAlign: 'center',
            }}>
              <Container maxWidth={300}>
                <img src={PredictionEmpty} alt='' width={'100%'} height={'auto'} />
              </Container>
              <Column gap={'0'} alignItems={'center'}>
                <h2 className={styles.h2}>Know What to Sell, Where to Focus, and When to Act!</h2>
                <p className={styles.p4} style={{ maxWidth: 747, }}>Predict products serving and get alerted about upcoming events that may boost demand.</p>
              </Column>
            </Column>
          </Column>
        </Column>
      </RenderIf>
      <RenderIf isTrue={data?.length !== 0}>
        <Row gap={15}>
          <CardV1 
            title={`Inventory Value`}
            filterTxt={`Next 7 Days`}
            value={formatCurrency(142000)}
            filterValue={`Previous Month`}
            percentage={`+4.04%`}
          />
          <CardV1 
            title={`Total Products`}
            filterTxt={`Next 7 Days`}
            value={`15.3K`}
            filterValue={`Previous Month`}
            percentage={`+4.04%`}
          />
          <CardV2 
            title={`Food Waste`}
            items={
              [
                {
                  icon: 'mixture-c2',
                  value: `5`,
                  title: `Mixtures Expiring`,
                },
                {
                  icon: 'ingredients-c2',
                  value: `5`,
                  title: `Ingredients Expiring`,
                },
                {
                  icon: 'items-c2',
                  value: `23`,
                  title: `Items Expiring`,
                },
              ]
            }
          />
          <CardV3 
            title={`Kitchen Planning`}
            description={`Lörem ipsum prerat kippavandring. Lånat fyst yre pår. Timellare hobäl och mibäst nyktig rev.`}
            butnTxt={`Kitchen Planning`}
          />
        </Row>
        <Column gap={21} padding={'20px 7.5px'} style={{
          background: '#FFFFFF',
          border: '#EDF2F7 1px solid',
          borderRadius: 10,
          boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
        }}>
          <Container maxWidth={1038}>
            <Column gap={'0'} padding={'11px 12px 11px 20px'} style={{
              border: '#EDF2F7 1px solid',
              borderRadius: 10,
              boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D;',
            }}>
              <Row gap={24} alignItems={'center'} style={{ minHeight: 85, }}>
                <Column gap={'0'} style={{ maxWidth: 167 }}>
                  <h4 className={styles.h4}>Upcoming Events</h4>
                </Column>
                <div style={{ flex: 1, maxWidth: '100%', overflow: 'hidden', }}>
                  <EventSlider />
                </div>
              </Row>
            </Column>
          </Container>
          <Row gap={15}>
            <Column gap={32} padding={'26px 40px'} style={{ flex: 1, }}>
              <DemandSpikeChart />
              <DemandBarChart />
            </Column>
            <Column width={312} padding={'24px 20px'}>
              <ChannelPerformanceChart />
            </Column>
          </Row>
          <Column gap={14}>
            <Row gap={15} justifyContent={'space-between'} padding={'0 13px'}>
              <h4>Prediction Polygon</h4>
              <div>
                <select className={styles.select}>
                  <option>Daily</option>
                  <option>Weekly</option>
                </select>
              </div>
            </Row>
            <div>
              <img src={PredictionPloygonMap} alt='' width={'100%'} height={'auto'} />
            </div>
          </Column>
          <Column gap={20} padding={'0 22px'}>
            <Row gap={20} alignItems={'center'}>
              <h4>Predicted Sales</h4>
              <Row gap={11} width={'auto'} alignItems={'center'}>
                <Row gap={2} width={'auto'} alignItems={'center'}>
                  <div className={styles.psChLabelDot} style={{ background: '#8D23DD' }}></div>
                  <div className={styles.psChLabelTitle}>Actual Sales</div>
                </Row>
                <Row gap={2} width={'auto'} alignItems={'center'}>
                  <div className={styles.psChLabelDot} style={{ background: '#66CB9F' }}></div>
                  <div className={styles.psChLabelTitle}>Predicted Sales</div>
                </Row>
              </Row>
            </Row>
            <div>
              <PredictedSaleBarChart />
            </div>
          </Column>
          <Column gap={20} padding={'0 22px'}>
            <Row gap={20} alignItems={'center'} justifyContent={'flex-end'}>
              <div>
                <Button 
                  onClick={() => {}} 
                  style={{
                      padding: '12px 20px',
                      borderRadius: 6,
                      height: 36,
                      background: 'var(--primary)',
                      color: '#FFFFFF',
                  }} 
                >
                  View Inventory
                </Button>
              </div>
              <div>
                <DateRangePicker
                  placeholder="Start date - End date"
                  onOk={() => {}}
                  onChange={() => {}}
                  showOneCalendar
                  defaultValue={[
                      new Date(moment().subtract(12, "month").valueOf()),
                      new Date(moment().valueOf()),
                  ]}
                  ranges={predefinedRanges}
                  className="dRangePickerInput autoWidth"
                  placement={'auto'}
                  format={pickerFormat}
                />
              </div>
            </Row>
            <Column gap={16} padding={'30px 24px'} style={{
              boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
              borderRadius: 10,
            }}>
              <Row gap={16} alignItems={'center'} justifyContent={'space-between'}>
                <h4>Predictions</h4>
                <div className={styles.inputBx}>
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={() => {}}
                  />
                  <Ikon name={'search-icon'} />
                </div>
              </Row>
              <Row gap={10} alignItems={'center'} justifyContent={'space-between'} padding={'10px 16px'} style={{
                background: '#FFFFFF',
                boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
                borderRadius: 10,
              }}>
                <Row gap={8} width={'auto'} alignItems={'center'}>
                  <img src={AvatarItem1} alt='' width={36} height={36} />
                  <p className={styles.p1_c4}>Bryaani</p>
                </Row>
                <Row gap={40} width={'auto'} alignItems={'center'}>
                  <Column gap={6} width={'auto'}>
                    <p className={styles.p2_c4}>Date</p>
                    <p className={styles.p3_c4}>25 May - 27 May</p>
                  </Column>
                  <Column gap={6} width={'auto'}>
                    <p className={styles.p2_c4}>Predicted Servings</p>
                    <p className={styles.p3_c4}>300<Ikon name={'double-arrow-up'} /></p>
                  </Column>
                  <Column gap={6} width={'auto'}>
                    <Button 
                      onClick={() => {}} 
                      style={{
                          padding: '8px 16px',
                          borderRadius: 26,
                          height: 26,
                          background: 'var(--primary)',
                          color: '#FFFFFF',
                      }} 
                    >
                      Override
                    </Button>
                  </Column>
                </Row>
              </Row>
              <Row gap={10} alignItems={'center'} justifyContent={'space-between'} padding={'10px 16px'} style={{
                background: '#FFFFFF',
                boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
                borderRadius: 10,
              }}>
                <Row gap={8} width={'auto'} alignItems={'center'}>
                  <img src={AvatarItem1} alt='' width={36} height={36} />
                  <p className={styles.p1_c4}>Karahi</p>
                </Row>
                <Row gap={40} width={'auto'} alignItems={'center'}>
                  <Column gap={6} width={'auto'}>
                    <p className={styles.p2_c4}>Date</p>
                    <p className={styles.p3_c4}>25 May - 27 May</p>
                  </Column>
                  <Column gap={6} width={'auto'}>
                    <p className={styles.p2_c4}>Predicted Servings</p>
                    <p className={styles.p3_c4}>300<Ikon name={'double-arrow-up'} /></p>
                  </Column>
                  <Column gap={6} width={'auto'}>
                    <Button 
                      onClick={() => {}} 
                      style={{
                          padding: '8px 16px',
                          borderRadius: 26,
                          height: 26,
                          background: 'var(--primary)',
                          color: '#FFFFFF',
                      }} 
                    >
                      Override
                    </Button>
                  </Column>
                </Row>
              </Row>
              <Row gap={10} alignItems={'center'} justifyContent={'space-between'} padding={'10px 16px'} style={{
                background: '#FFFFFF',
                boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D',
                borderRadius: 10,
              }}>
                <Row gap={8} width={'auto'} alignItems={'center'}>
                  <img src={AvatarItem1} alt='' width={36} height={36} />
                  <p className={styles.p1_c4}>Pulao</p>
                </Row>
                <Row gap={40} width={'auto'} alignItems={'center'}>
                  <Column gap={6} width={'auto'}>
                    <p className={styles.p2_c4}>Date</p>
                    <p className={styles.p3_c4}>25 May - 27 May</p>
                  </Column>
                  <Column gap={6} width={'auto'}>
                    <p className={styles.p2_c4}>Predicted Servings</p>
                    <p className={styles.p3_c4}>100<Ikon name={'double-arrow-down'} /></p>
                  </Column>
                  <Column gap={6} width={'auto'}>
                    <Button 
                      onClick={() => {}} 
                      style={{
                          padding: '8px 16px',
                          borderRadius: 26,
                          height: 26,
                          background: 'var(--primary)',
                          color: '#FFFFFF',
                      }} 
                    >
                      Override
                    </Button>
                  </Column>
                </Row>
              </Row>
            </Column>
          </Column>
        </Column>
      </RenderIf>
      {/* <RenderIf isTrue={}>
      </RenderIf> */}
    </Column>
  );
};
